export const OFFSET_X = 16;
export const OFFSET_Y = 18;
const MARGIN = 8;

export function placeAtPointer({ x, y, width, height, viewport }) {
  let left = x + OFFSET_X;
  let top = y + OFFSET_Y;
  if (left + width > viewport.width - MARGIN) left = x - width - OFFSET_X;
  if (top + height > viewport.height - MARGIN) top = y - height - OFFSET_Y;
  return { left: Math.max(MARGIN, left), top: Math.max((viewport.top || 0) + MARGIN, top) };
}

export function placeBeside({ anchor, width, height, viewport, gap = 4 }) {
  let left = anchor.right + gap;
  if (left + width > viewport.width - MARGIN) left = anchor.left - width - gap;
  const top = Math.min(anchor.top + 6, viewport.height - height - MARGIN);
  return { left: Math.max(MARGIN, left), top: Math.max(MARGIN, top) };
}
